import React, { useState } from "react";

// Componentes
import { Card, CardBody, Button, CardTitle, Collapse, Row } from "reactstrap";
import CustomForm from "../../../components/CustomForm/CustomForm";
import SectionComponent from "../../Apps/Personalization/SectionComponent";

export default function EditForm(props) {
  const [isOpen, setIsOpen] = useState(false);

  // Retorna para a listagem de formulários
  const handleBack = () => props.setStep("_a");

  return (
    <Card>
      <CardBody>
        <CardTitle>Editar formulário</CardTitle>
        <div className="mobile-btn-section" style={{ width: "100%" }}>
          <SectionComponent
            sectionName="Opções"
            setIsOpen={setIsOpen}
            isOpen={isOpen}
          />
          <Collapse isOpen={isOpen}>
            <Row className="mobile-btns-top">
              <div onClick={handleBack}>Voltar</div>
            </Row>
          </Collapse>
        </div>
        <div className="header-btns-container">
          <Button color="danger" className="btn-sm px-4" onClick={handleBack}>
            Voltar
          </Button>
        </div>
        <CustomForm
          toggle={handleBack}
          createOrUpdate="update"
          eventId={props.eventId}
          selectedForm={props.selectedForm}
          action="U"
        />
      </CardBody>
    </Card>
  );
}
